import { render } from "./TheCanvas.vue?vue&type=template&id=71e081bc"
import script from "./TheCanvas.vue?vue&type=script&lang=js"
export * from "./TheCanvas.vue?vue&type=script&lang=js"

import "./TheCanvas.vue?vue&type=style&index=0&id=71e081bc&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__